import type { Locale } from '@ufc/i18n'
import { enTranslations } from './en'
import { arTranslations } from './ar'
import { urTranslations } from './ur'
import type { AssetsTranslations } from './types'

/**
 * Assets domain translations
 * Use in portals: t('assets.title'), t('assets.form.name'), etc.
 */
export const assetsTranslations: Record<Locale, AssetsTranslations> = {
  en: enTranslations,
  ar: arTranslations,
  ur: urTranslations,
}

/**
 * Create namespaced translations for portal integration
 * Usage in portal i18n.ts:
 *
 * import { createNamespacedAssetsTranslations } from '@ufc/domains/assets'
 *
 * const resources = {
 *   en: {
 *     translation: {
 *       ...coreTranslations.en,
 *       ...createNamespacedAssetsTranslations().en,
 *     }
   },
 *   ar: { ... },
 *   ur: { ... }
 * }
 */
export const createNamespacedAssetsTranslations = () => ({
  en: {
    assets: enTranslations,
  },
  ar: {
    assets: arTranslations,
  },
  ur: {
    assets: urTranslations,
  },
})

// Export translations and types
export { enTranslations, arTranslations, urTranslations }
export type { AssetsTranslations }

// Export flat translations for direct import
export const assetsTranslationEn = enTranslations
export const assetsTranslationAr = arTranslations
export const assetsTranslationUr = urTranslations